import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/modules/shared/shared-module";
import { NgxEmojiPickerModule } from "ngx-emoji-picker";
import { PushNotificationRoutingModule } from "./push-notification-routing.module";
import {
  PushNotificationCreationComponent,
  PushNotificationListingComponent,
} from "./pages";

@NgModule({
  declarations: [
    PushNotificationCreationComponent,
    PushNotificationListingComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxEmojiPickerModule,
    PushNotificationRoutingModule,
  ],
})
export class PushNotificationModule {}
